import React from "react";
import { TextInput } from "@traceair/tds";
import { style } from "typestyle";
import { MatrixState } from "./useMatrixState";

const cellStyle = style({
  verticalAlign: "top",
  height: "60px",
  paddingRight: "15px",
  $nest: {
    "&:last-child": {
      paddingRight: "0px",
    },
  },
});

const TranslationMatrixInput = ({
  matrix,
  errors,
  setMatrixValue,
}: MatrixState) => {
  return (
    <table>
      <tbody>
        <tr>
          <td className={cellStyle}>
            <TextInput
              value={matrix[0]}
              isInvalid={!!errors[0]}
              errorMessage={errors[0]}
              onChange={(value) => setMatrixValue(0, value)}
            />
          </td>
          <td className={cellStyle}>
            <TextInput
              value={matrix[1]}
              isInvalid={!!errors[1]}
              errorMessage={errors[1]}
              onChange={(value) => setMatrixValue(1, value)}
            />
          </td>
          <td className={cellStyle}>
            <TextInput
              value={matrix[2]}
              isInvalid={!!errors[2]}
              errorMessage={errors[2]}
              onChange={(value) => setMatrixValue(2, value)}
            />
          </td>
        </tr>
        <tr>
          <td className={cellStyle}>
            <TextInput
              value={matrix[3]}
              isInvalid={!!errors[3]}
              errorMessage={errors[3]}
              onChange={(value) => setMatrixValue(3, value)}
            />
          </td>
          <td className={cellStyle}>
            <TextInput
              value={matrix[4]}
              isInvalid={!!errors[4]}
              errorMessage={errors[4]}
              onChange={(value) => setMatrixValue(4, value)}
            />
          </td>
          <td className={cellStyle}>
            <TextInput
              value={matrix[5]}
              isInvalid={!!errors[5]}
              errorMessage={errors[5]}
              onChange={(value) => setMatrixValue(5, value)}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default TranslationMatrixInput;
